import { EventTypes } from 'redux-segment';
import canUseDOM from '../../common/utils/canUseDom';

// All segment events should fire the same action.
export const SEGMENT_EVENT = 'SEGMENT_EVENT';

/**
 * Segment action used to identify a page event
 *
 * This action should typically get called from the constructor. Any meta
 * data required to fire the action can be passed through from the connected
 * route container.
 *
 * @param {Object} payload an object to send the event payload request.
 */
export const navigatedToPage = (name, category, properties = {}, integrations = {}) => (dispatch) => {
  if (canUseDOM) {
    dispatch({
      type: SEGMENT_EVENT,
      meta: {
        analytics: {
          eventType: EventTypes.page,
          eventPayload: {
            name,
            category,
            properties,
            integrations
          },
        },
      },
    });
  }
};


/**
 * A common action meant to be triggered when a CTA is clicked. This is probably
 * best triggered from the `onClick` component hook.
 *
 * @param {String} ctaLocation location relative to the page that the CTA is rendered
 * @param {String} pageName the name of the page containing the CTA
 */
export const clickedSubscribeCTA = properties => ({
  type: SEGMENT_EVENT,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Clicked Subscribe CTA',
        properties: { ...properties },
      },
    },
  },
});

/**
 * A common action meant to be triggered when a user is using an ad blocker.
 *
 * @param {String} properties object containing properties related to event
 */
export const detectedAdBlock = properties => ({
  type: SEGMENT_EVENT,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Detected Ad Blocker',
        properties,
      },
    },
  },
});

/**
 * A shared action meant to be triggered for misc actions. This is probably
 * best triggered from the `onClick` component hook.
 *
 * @param {String} name event name
 * @param {Object} properties properties for the corresponding event
 */
export const trackEvent = (name, properties = {}) => async (dispatch) => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: name,
          properties: { ...properties },
        },
      },
    },
  });
};
